<!-- BEGIN #content -->
<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Smart Irrigation</a>
        </li>
        <li class="breadcrumb-item" >
          <a>Schedules</a>
        </li>
      </ol>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight pt-3">
  
    <div class="row mt-2">
      <div class="col-lg-12 col-sm-12">
        <div class="card mb-4">
          <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            <span class="flex-grow-1">Schedules</span>
          </div>
          <div class="card-body p-0">
            
            

          </div>
        </div>
      </div>


    
  </div>


